const data = {
	"width": 24,
	"height": 24,
	"hidden": true,
	"body": "<path fill=\"currentColor\" d=\"M4.42 20.579a1 1 0 0 1-.737-.326a.988.988 0 0 1-.263-.764l.245-2.694L14.983 5.481l3.537 3.536L7.205 20.33l-2.694.245a.95.95 0 0 1-.091.004ZM19.226 8.31L15.69 4.774l2.121-2.121a1 1 0 0 1 1.415 0l2.121 2.121a1 1 0 0 1 0 1.415l-2.12 2.12l-.001.001Z\"/>"
};
exports.__esModule = true;
exports.default = data;
